import { connect } from 'react-redux';
import { routerStateExists, getRouteParams } from '@confluence-classic/confluence-urls';
import { isContentTypeOf } from '@confluence-classic/confluence-legacy-redux';

import { DELETE_SPACE_LEGACY } from '@confluence/named-routes';

import StandaloneConfluenceNavigation from './StandaloneConfluenceNavigation';

const getSpaceKey = (state) => {
	const routeParams = getRouteParams(state);
	return (
		(routerStateExists(state) && routeParams && routeParams.spaceKey) ||
		state.meta.get('space-alias') ||
		state.meta.get('space-key')
	);
};

const mapStateToProps = (state, props) => {
	const { location, matchRoute } = props;

	const isSpaceScreen =
		state.meta.get('is-space-page') === 'true' ||
		isContentTypeOf('page', state) ||
		isContentTypeOf('blogpost', state);

	//On the DELETE_SPACE_LEGACY path the space is already deleted but certain queries
	//use the spaceKey. Set spaceKey to null if on this path
	const route = matchRoute(`${location.pathname}${location.search}${location.hash}`);

	const spaceKey = route?.name === DELETE_SPACE_LEGACY.name ? null : getSpaceKey(state);

	return {
		isAdminScreen: state.meta.get('is-admin-page') === 'true',
		isSpaceScreen,
		isSpaceSettingsScreen: state.meta.get('is-space-tool-page') === 'true',
		route,
		spaceKey,
	};
};

export default connect(mapStateToProps)(StandaloneConfluenceNavigation);
